import React from 'react'

function LoaderSmall() {
    return (
        <div >
            <img alt="loading" style={{maxWidth: "40px"}} src="https://smorasstats.com/v4/wp-content/uploads/2020/05/loader.gif" className="loadingSpinner" />
        </div>
    )
}
export default LoaderSmall